import Search from '../search/search';
export default Search;